module.exports = __webpack_public_path__ + "static/media/filename (4).b316dc90.png";